(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('CountryRisk', CountryRisk);

    CountryRisk.$inject = ['$resource'];

    function CountryRisk ($resource) {
        var resourceUrl =  'api/risks';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
